import { Field } from 'formik';
import { twMerge } from 'tailwind-merge';

type FieldProps = {
  fieldClassName?: string;
  name: string;
  label: string;
  textArea?: boolean;
};

const FormField = ({ fieldClassName, name, label, textArea }: FieldProps) => {
  const fieldTwClassName = 'border-1 border-solid border-gray-medium h-12 p-3';

  return (
    <>
      <label className="body mb-2" htmlFor={name}>
        {label}
      </label>
      <Field
        as={textArea ? 'textarea' : undefined}
        className={twMerge(fieldTwClassName, fieldClassName)}
        id={name}
        name={name}
      />
    </>
  );
};

export default FormField;
